import React from 'react';
import Button from '@mui/material/Button';

// Sign in with a git.femorph.com (Gitea) account. Same-origin relative path so
// it works on femorph.com and any preview origin without hardcoding the host.
// This is the replacement for the retired GitHub login: any account that can
// sign in to git.femorph.com can sign in to the portal.
const GITEA_AUTH_URL = '/auth/gitea';

const LoginGitea = () => {
  return (
    <Button
      variant="contained"
      color="primary"
      fullWidth
      onClick={() => { window.location.href = GITEA_AUTH_URL; }}
    >
      Sign in with git.femorph.com
    </Button>
  );
};

export default LoginGitea;
